import styled from 'styled-components'
export const SpeedAdjustmentButton = styled.button`
    background: none;
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    font-size: 23px;
    margin-bottom: 4px;
    font-family: inherit;
    color: ${p => p.theme.playerIconsColor};

    ${p => p.theme.utils.flex({})};

    span {
        font-size: 18px;
        margin-top: auto;
        transform: translateY(-2px);
    }
`
